export const siteInfo = {
  name: '黑料吃瓜在线',
  tagline: '最新最全的吃瓜爆料平台',
  slogan: '每天更新，吃瓜不停歇',
  description: '黑料吃瓜在线是国内领先的娱乐八卦与热点事件聚合平台，每日精选全网最新黑料吃瓜在线观看资源，覆盖明星八卦、社会事件、网络爆料等多个领域。我们以最快的速度、最全的视角，为您呈现每一次精彩吃瓜时刻。',
  heroStats: [
    { label: '每日更新', value: '200+' },
    { label: '独家爆料', value: '5000+' },
    { label: '活跃吃瓜群众', value: '300万+' },
  ],
};

export const topicsData = [
  { id: 1, name: '娱乐圈塌房', count: '12.8万', hot: true },
  { id: 2, name: '网红翻车', count: '9.6万', hot: true },
  { id: 3, name: '明星恋情', count: '8.3万', hot: true },
  { id: 4, name: '直播爆料', count: '7.1万', hot: false },
  { id: 5, name: '综艺名场面', count: '6.5万', hot: false },
  { id: 6, name: '社会事件', count: '5.9万', hot: false },
  { id: 7, name: '品牌翻车', count: '5.2万', hot: false },
  { id: 8, name: '选秀内幕', count: '4.8万', hot: false },
  { id: 9, name: '影视争议', count: '4.3万', hot: false },
  { id: 10, name: '饭圈热议', count: '3.9万', hot: false },
];

export const indexData = [
  { id: 1, title: '2026上半年娱乐圈大盘点', desc: '回顾上半年最劲爆的十大瓜', count: 128, tag: '热门' },
  { id: 2, title: '直播带货翻车合集', desc: '那些年主播们的大型翻车现场', count: 96, tag: '精选' },
  { id: 3, title: '明星人设崩塌实录', desc: '从顶流到塌房，全过程梳理', count: 87, tag: '爆款' },
  { id: 4, title: '综艺节目名场面', desc: '那些让人笑到肚子疼的综艺瞬间', count: 74, tag: '推荐' },
  { id: 5, title: '品牌公关危机事件', desc: '大品牌如何应对舆论风暴', count: 63, tag: '深度' },
  { id: 6, title: '网红圈年度大事件', desc: '网红圈最轰动的十大事件回顾', count: 55, tag: '专题' },
  { id: 7, title: '影视剧穿帮镜头集锦', desc: '那些被观众抓包的穿帮时刻', count: 48, tag: '趣味' },
];

export const cardsData = [
  { id: 1, title: '某顶流男星深夜密会神秘女子，工作室紧急发声', desc: '据知情人士透露，该男星与神秘女子在某高档餐厅共进晚餐长达三小时，期间举止亲密。', time: '2小时前', views: '128万', tag: '娱乐圈' },
  { id: 2, title: '知名网红直播带货翻车，产品质量遭粉丝集体维权', desc: '千万粉丝网红被曝直播间售卖的商品存在严重质量问题，目前已有多位消费者联合发起维权。', time: '5小时前', views: '96万', tag: '网红圈' },
  { id: 3, title: '某综艺节目录制现场突发意外，节目组紧急暂停拍摄', desc: '据悉该节目为一档竞技类真人秀，录制过程中一名嘉宾不慎受伤，目前已被送往医院。', time: '8小时前', views: '85万', tag: '综艺' },
  { id: 4, title: '知名品牌广告涉抄袭争议，官方回应引网友不满', desc: '该品牌最新广告片被指抄袭某独立设计师作品，品牌方面回应称纯属巧合，但网友并不买账。', time: '12小时前', views: '73万', tag: '社会' },
  { id: 5, title: '某女星现身机场素颜照曝光，网友直呼认不出', desc: '一向以精致形象示人的女星近日被拍到素颜现身机场，与平日形象判若两人。', time: '1天前', views: '68万', tag: '娱乐圈' },
  { id: 6, title: '热门网剧导演被爆拖欠剧组工资，剧组工作人员集体讨薪', desc: '据悉该导演的新剧正在热播，但剧组多名工作人员反映工资已拖欠数月未发。', time: '1天前', views: '55万', tag: '影视' },
  { id: 7, title: '某选秀节目选手背景造假被扒，节目组表示将严肃处理', desc: '有网友扒出该选手学历及工作经历存在多处造假，节目组已启动调查程序。', time: '2天前', views: '42万', tag: '选秀' },
];

export const rankingData = [
  { rank: 1, title: '顶流男星深夜密会神秘女子', heat: '128万', trend: 'up', change: '+32%' },
  { rank: 2, title: '网红直播带货翻车维权事件', heat: '96万', trend: 'up', change: '+18%' },
  { rank: 3, title: '综艺录制现场突发意外', heat: '85万', trend: 'up', change: '+45%' },
  { rank: 4, title: '知名品牌广告抄袭争议', heat: '73万', trend: 'down', change: '-8%' },
  { rank: 5, title: '女星素颜照引热议', heat: '68万', trend: 'up', change: '+22%' },
  { rank: 6, title: '网剧导演拖欠工资事件', heat: '55万', trend: 'new', change: '新上榜' },
];

export const faqData = [
  { id: 1, question: '黑料吃瓜在线每天都更新内容吗？', answer: '是的！我们拥有专业的编辑团队，每天24小时不间断监测全网热点，确保您能在第一时间获取最新、最热的吃瓜内容。日均更新超过200条精选爆料，涵盖娱乐八卦、社会事件、网络热议等多个板块。' },
  { id: 2, question: '如何确保爆料的真实性和可靠性？', answer: '我们采用多重信息验证机制，每条爆料在发布前都会经过编辑团队的核实与筛选。对于未经证实的信息，我们会标注"待核实"标签。同时我们也鼓励广大吃瓜群众在评论区补充信息和纠错，共同维护平台内容质量。' },
  { id: 3, question: '可以在手机上观看黑料吃瓜在线的视频吗？', answer: '当然可以！黑料吃瓜在线全面支持移动端访问，无论是手机浏览器还是平板设备，都能流畅观看高清视频内容。我们针对移动端做了专门的播放优化，确保您随时随地都能畅快吃瓜。' },
  { id: 4, question: '如何向我们投稿或提供爆料线索？', answer: '您可以通过页面底部的"联系我们"板块找到投稿邮箱和联系方式。我们鼓励知情人士和热心网友提供有价值的爆料线索，对于采用的优质内容，我们会给予相应的奖励和署名权。' },
  { id: 5, question: '黑料吃瓜在线和其他娱乐平台有什么不同？', answer: '我们的核心优势在于"快、全、真"——快：7x24小时实时更新，热点事件绝不遗漏；全：覆盖娱乐圈、网红圈、社会事件等多维度内容；真：严格的信息审核机制，拒绝虚假信息和恶意炒作。' },
];

export const commentsData = [
  { id: 1, name: '吃瓜一线群众', avatar: 'C', content: '这瓜保熟吗？每天蹲在这儿等更新，比追剧还上瘾！今天的料太猛了，上班摸鱼都不舍得关页面。', time: '3分钟前', likes: 1286 },
  { id: 2, name: '资深八卦研究员', avatar: '八', content: '作为追了十年八卦的老粉，这个平台的信息整合能力确实强。比起其他平台的信息碎片化，这里的专题整理很有深度，适合深度吃瓜。', time: '15分钟前', likes: 956 },
  { id: 3, name: '冷静吃瓜不站队', avatar: '冷', content: '建议大家理性吃瓜，不要盲目跟风站队。这个平台好在会标注信息核实状态，比那些只会煽动情绪的营销号强多了。', time: '28分钟前', likes: 723 },
  { id: 4, name: '夜猫子吃瓜人', avatar: '夜', content: '凌晨三点还在刷，请问我还有救吗？不过说真的，更新的速度确实快，很多料都是在这儿首发的，已经安利给身边所有朋友了。', time: '42分钟前', likes: 541 },
];

export const featuresData = [
  { id: 1, icon: 'ri-flashlight-line', title: '极速更新', desc: '7×24小时全天候监测，热点事件第一时间推送，绝不让你错过任何一个瓜。' },
  { id: 2, icon: 'ri-shield-check-line', title: '信息核验', desc: '多重信息验证机制，标注爆料可信度，让你吃放心瓜、吃明白瓜。' },
  { id: 3, icon: 'ri-smartphone-line', title: '多端同步', desc: '电脑、手机、平板无缝切换，随时随地畅享高清吃瓜体验。' },
  { id: 4, icon: 'ri-group-line', title: '社区互动', desc: '百万吃瓜群众在线交流，评论区金句频出，吃瓜乐趣翻倍。' },
  { id: 5, icon: 'ri-article-line', title: '深度专题', desc: '专业编辑团队打造深度专题，从事件起因到后续发展，一网打尽。' },
];

export const updatesData = [
  { id: 1, time: '10:42', title: '某影视公司被曝拖欠艺人片酬，涉及多位知名演员', tag: '最新' },
  { id: 2, time: '09:15', title: '热门网综选手被扒曾参加多个选秀节目，身份造假疑云重重', tag: '热门' },
  { id: 3, time: '08:30', title: '知名品牌官宣新代言人，网友：这波操作太迷了', tag: '热议' },
  { id: 4, time: '07:00', title: '某男星被拍到与绯闻女友同游日本，粉丝：坐等官宣', tag: '绯闻' },
  { id: 5, time: '昨日 22:30', title: '直播平台头部主播涉虚假宣传遭平台封禁三个月', tag: '独家' },
  { id: 6, time: '昨日 19:00', title: '某电竞赛事被曝假赛丑闻，赛事方启动全面调查', tag: '事件' },
  { id: 7, time: '昨日 16:15', title: '热门短视频博主内容涉嫌抄袭海外创作者，评论区沦陷', tag: '争议' },
];

export const carouselData = [
  { id: 1, title: '2026娱乐圈年中吃瓜报告', desc: '半年盘点：从塌房到逆袭，娱乐圈那些让人跌破眼镜的瞬间。包含12个重点事件深度分析。', tag: '年度专题', color: 'from-primary-600 to-accent-600' },
  { id: 2, title: '直播带货：从风口到翻车', desc: '深度调查：直播带货行业乱象频出，消费者权益如何保障？揭秘头部主播背后的商业逻辑。', tag: '深度调查', color: 'from-accent-600 to-secondary-600' },
  { id: 3, title: '网红产业链大揭秘', desc: '从素人到顶流，揭秘网红背后的资本运作与流量密码。一条价值千万的内容是如何诞生的？', tag: '产业观察', color: 'from-secondary-600 to-primary-600' },
  { id: 4, title: '社交媒体时代的真相与谣言', desc: '在信息爆炸的时代，如何辨别真假瓜？我们请来了资深媒体人和法律专家为你支招。', tag: '特别企划', color: 'from-primary-500 to-accent-500' },
];

export const aboutData = {
  title: '关于黑料吃瓜在线',
  content: '黑料吃瓜在线成立于2024年，是国内领先的娱乐八卦与热点事件聚合平台。我们致力于为广大吃瓜群众提供最新、最全、最真实的黑料吃瓜在线观看与黑料吃瓜在线播放服务。平台汇聚了来自全国各地的热心网友和资深娱乐记者，每天为您精选最值得关注的热点事件。我们的愿景是成为中文互联网最值得信赖的吃瓜平台，让每一个热爱八卦的人都能在这里找到属于自己的快乐。无论是娱乐圈的大瓜小瓜，还是社会事件的热点追踪，黑料吃瓜在线都将是您最可靠的吃瓜伙伴。',
};

export const contactData = {
  title: '联系我们',
  intro: '有料要爆？有瓜要分享？欢迎通过以下方式联系我们。我们珍视每一条有价值的线索，对于采用的优质内容将给予丰厚奖励。',
  email: 'tips@heiliao.cc',
  wechat: 'heiliao_chigua',
  qq: '800123456',
};

export const appData = {
  title: '随时随地，畅快吃瓜',
  desc: '黑料吃瓜在线移动端适配完美，无需下载安装，打开浏览器即可畅享完整功能。支持添加到手机桌面，一键直达最新爆料。',
  qrUrl: 'https://readdy.ai/api/search-image?query=A%20minimalist%20QR%20code%20style%20illustration%20with%20warm%20orange%20and%20gold%20accents%20on%20a%20clean%20white%20background%2C%20modern%20clean%20design%2C%20subtle%20gradient%2C%20editorial%20style&width=400&height=400&seq=app-qr-01&orientation=squarish',
};

export const mediaData = [
  { id: 1, title: '顶流塌房全记录：从巅峰到谷底', duration: '15:28', views: '258万', tag: '深度解析' },
  { id: 2, title: '揭秘网红直播间的那些套路', duration: '12:45', views: '186万', tag: '行业揭秘' },
  { id: 3, title: '娱乐圈最尴尬的十大名场面', duration: '08:32', views: '312万', tag: '趣味盘点' },
  { id: 4, title: '2026年最大反转：那些被打脸的预言', duration: '10:15', views: '145万', tag: '年度回顾' },
  { id: 5, title: '明星综艺后台花絮合集', duration: '06:58', views: '98万', tag: '独家花絮' },
];